import { faFileArrowDown } from '@fortawesome/pro-regular-svg-icons/faFileArrowDown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, CircularProgress } from '@mui/material';
import React, { useCallback, useState } from 'react';
import { getAttachment } from '../api';

export interface AttachmentLinkProps {
  attachmentKey: string;
}

const AttachmentLink = ({ attachmentKey }: AttachmentLinkProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleOpenFile = useCallback(async () => {
    if (!attachmentKey || isLoading) return;

    setIsLoading(true);
    try {
      const response = await getAttachment(attachmentKey);
      const attachmentUrl = response?.parsedBody?.url as string;

      if (attachmentUrl) {
        window.open(attachmentUrl, '_blank');
      }
    } catch (error) {
      console.error('Failed to fetch attachment URL:', error);
    } finally {
      setIsLoading(false);
    }
  }, [attachmentKey, isLoading]);

  return (
    <Button
      variant="outlined"
      size="small"
      onClick={handleOpenFile}
      disabled={isLoading}
      startIcon={
        isLoading ? (
          <CircularProgress size={16} thickness={4} />
        ) : (
          <FontAwesomeIcon icon={faFileArrowDown} />
        )
      }
      sx={{
        textTransform: 'none',
        borderRadius: '6px',
        height: '32px',
        padding: '6px 12px',
        fontSize: '0.875rem',
        fontWeight: 500,
        color: 'primary.main',
        borderColor: 'primary.main',
        '&:hover': {
          backgroundColor: 'primary.main',
          color: 'white',
          borderColor: 'primary.main',
        },
        '&:disabled': {
          opacity: 0.7,
          color: 'text.secondary',
          borderColor: 'divider',
        },
      }}
    >
      {isLoading ? 'Loading...' : 'Open file'}
    </Button>
  );
};

export default AttachmentLink;
